import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "../../assets/css/Useraccount.css";
import { Button } from "primereact/button";
import { Sidebar } from "primereact/sidebar";
import { Badge } from "primereact/badge";
import Invoices from "./Invoices";
import api from "../../api/axios";
import moment from "moment";
import { Paginator } from "primereact/paginator";
import { useAuth } from "../../context/AuthContext";
import { toast } from "react-toastify";

const Billing = () => {
  const { username } = useAuth();
  const [visibleRight3, setVisibleRight3] = useState(false);

  const ITEMS_PER_PAGE = 10;

  const [invoices, setInvoices] = useState([]);
  const [page, setPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [downloadingInvoiceId, setDownloadingInvoiceId] = useState(null);

  const fetchInvoices = async (page = 1) => {
    try {
      setLoading(true);

      const res = await api.get(`/customerProfileRoutes/customer/invoices`, {
        params: { page, limit: ITEMS_PER_PAGE },
      });

      if (res.data.success) {
        setInvoices(res.data.data);
        setTotalRecords(res.data.pagination.totalRecords);
      }
    } catch (err) {
      console.error("Failed to fetch invoices", err);
      toast.error("Failed to fetch invoices");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInvoices(page);
  }, [page]);

  const handleInvoiceDownload = async (invoiceId) => {
    if (downloadingInvoiceId === invoiceId) return;

    try {
      setDownloadingInvoiceId(invoiceId);

      const res = await api.get(`/InvoicePDFRoutes/invoice/download/${invoiceId}`);

      if (!res?.data?.success || !res?.data?.download_url) {
        toast.error("Invoice download link not available");
        return;
      }

      const link = document.createElement("a");
      link.href = res.data.download_url;
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      document.body.appendChild(link);
      link.click();
      link.remove();

      toast.success("Invoice download started");
    } catch (err) {
      console.error("Failed to download invoice", err);
      toast.error(
        err?.response?.data?.message || "Failed to download invoice"
      );
    } finally {
      setDownloadingInvoiceId(null);
    }
  };

  return (
    <>
      <Row className="mx-0 breadcrumb_part">
        <Col md={12} lg={12} xs={12} className="prof_title mb-4">
          <h4>Billing</h4>
        </Col>

        <Row className="mx-0 mt-0 packCard bg-transparent px-0">
          <p className="mb-3 border-bottom pb-3">Billing information</p>

          <div className="d-flex flex-wrap align-items-center gap-2 justify-content-between">
            <p style={{ lineHeight: "1.35" }}>
              <b>{username}</b> <br />
            </p>
            <div></div>
          </div>
        </Row>

        <Row className="mx-0 mt-0 packCard bg-transparent px-0">
          <Col md={12} lg={12} xs={12}>
            <p className="mb-3 border-bottom pb-3">Invoices</p>
          </Col>

          <Col md={12} lg={12} xs={12}>
            <div className="table-wrapper invoice-table">
              <Table className="custom-table">
                <Thead className="sticky-thead">
                  <Tr>
                    <Th>Product</Th>
                    <Th>Invoice Number</Th>
                    <Th>Date</Th>
                    <Th>Amount</Th>
                    <Th>Status</Th>
                    <Th style={{ width: "90px" }}>Action</Th>
                  </Tr>
                </Thead>

                <Tbody>
                  {loading && (
                    <Tr>
                      <Td colSpan="6" className="text-center py-4">
                        Loading invoices...
                      </Td>
                    </Tr>
                  )}

                  {!loading && invoices.length === 0 && (
                    <Tr>
                      <Td colSpan="6" className="text-center py-4">
                        No invoices found
                      </Td>
                    </Tr>
                  )}

                  {invoices.map((item) => (
                    <Tr key={item.cinv_id} className="table-row">
                      <Td>{item.sub_name}</Td>

                      <Td>{item.Inv_no}</Td>

                      <Td>
                        {item.issued_at
                          ? moment(item.issued_at).format("DD/MM/YYYY hh:mm A")
                          : "-"}
                      </Td>

                      <Td>₹{Number(item.final_price).toFixed(2)}</Td>

                      <Td>
                        <Badge
                          value={item.payment_status}
                          severity={
                            item.payment_status === "Completed"
                              ? "success"
                              : item.payment_status === "Processing"
                                ? "warning"
                                : "danger"
                          }
                        />
                      </Td>

                      <Td>
                        <Button
                          icon="pi pi-eye"
                          severity="warning"
                          className="py-1"
                          tooltip="View Invoice"
                          tooltipOptions={{ position: "top" }}
                          text
                          onClick={() => {
                            setSelectedInvoice(item);
                            setVisibleRight3(true);
                          }}
                          style={{ fontSize: "14px", width: "fit-content" }}
                        />

                        <Button
                          icon={
                            downloadingInvoiceId === item.cinv_id
                              ? "pi pi-spin pi-spinner"
                              : "pi pi-download"
                          }
                          severity="success"
                          className="py-1 ms-2"
                          tooltip="Download Invoice"
                          tooltipOptions={{ position: "top" }}
                          text
                          style={{ fontSize: "14px", width: "fit-content" }}
                          onClick={() => handleInvoiceDownload(item.cinv_id)}
                          disabled={downloadingInvoiceId === item.cinv_id}
                        />
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </div>

            <Paginator
              first={(page - 1) * ITEMS_PER_PAGE}
              rows={ITEMS_PER_PAGE}
              totalRecords={totalRecords}
              onPageChange={(e) => setPage(e.page + 1)}
            />
          </Col>
        </Row>
      </Row>

      <Sidebar
        visible={visibleRight3}
        className="shortCartSide"
        position="right"
        onHide={() => {
          setVisibleRight3(false);
          setSelectedInvoice(null);
        }}
        style={{ width: "800px" }}
      >
        <Invoices invoice={selectedInvoice} />
      </Sidebar>
    </>
  );
};

export default Billing;